<template>
  <div class="sales-main">
    <div class="option-container">  
      <!-- <DateTimePicker style="padding-left: 10px; width: 450px;" title="Invoice Date From" :showTime="false" :value.sync="fromDate" :maxDate="toDate"/>
      <DateTimePicker style="" title="To" :showTime="false" :value.sync="toDate" :minDate="fromDate"/>
      <div class="chkBox-show-pl-txn-only">
          <input class="chkBox" type="checkbox" v-model="isChecked"> 
          <span style="position: relative; top: -2px;">Show P&L txn only</span>
      </div>
      <button @click="refreshChart">Refresh</button>

      <span class="refresh-last">Last Refreshed: {{refreshDate}}</span> -->
      <div class="filter-list">
        <!-- <DateTimePicker style="padding-left: 10px; width: 450px;" title="Invoice Date From" :showTime="false" :value.sync="fromDate" :maxDate="toDate"/> -->
        <DateTimePicker title="AR Invoice Date From" :showTime="false" :value.sync="fromDate" :maxDate="toDate"/>
        <DateTimePicker style="margin-left: 20px;" title="To" :showTime="false" :value.sync="toDate" :minDate="fromDate"/>
        <CheckBox style="margin-left: 20px;" class="chkBox-show-pl-txn-only" title="Show P&L txn only" :isChecked.sync="isChecked" />
        <button style="margin-left: 20px;" @click="refreshChart">Refresh</button>
      </div>
      <div class="last-refresh">
        <span>Last Refreshed: {{refreshDate}}</span>
      </div>
    </div>

    <div class="top-chart-container">
      <div class="title-top-chart">
        <span class="barlinechart-title">Total Sales vs Collection by Sales Person</span>
        <div class="custom-legend">
          <div class="legend-box-Sales"></div>
          <span style="margin-right: 40px;">Sales</span>
          <div class="legend-box-Collection1"></div>
          <div class="legend-box-Collection2"></div>
          <div class="legend-box-Collection3"></div>
          <div class="legend-box-Collection4"></div>
          <div class="legend-box-Collection5"></div>
          <span style="margin-right: 10px;">Collection</span>
        </div>
      </div>
      <div class="barlinechart-table" id="barlinechart-table">
        <div class="barlineChart-Sales" id="barlineChart-Sales"></div>
        <div class="barline2Chart-Sales" id="barline2Chart-Sales"></div>
      </div>
    </div>

    <div class="bottom-chart-container">
      <div class="piechart-table" id="piechart-table">
        <div class="pie-chart-title">Total Sales by Transaction Group</div>
        <div class="pie-chart-container">
          <div class="pie-chart-Sales" id="pie-chart-Sales"></div>
          <div class="legend">
            <div class="legend-row">
              <div class="table">
                <table class="details-table">
                  <tr>
                    <th :style="{ border: '1px solid black', padding: '3px !important' }">Legend</th>
                    <th :style="{ border: '1px solid black', padding: '3px !important' }">Total Sales</th>
                    <th :style="{ border: '1px solid black', padding: '3px !important' }">Percentages</th>
                  </tr>
                  <tr v-for="l in customLegend" :key="l">
                    <td :style="{ textAlign: 'left', border: '1px solid black', padding: '3px !important' }">{{ l.name }}</td>
                    <td :style="{ border: '1px solid black', padding: '3px !important' }">{{l.currency}} {{ l.value }}</td>
                    <td :style="{ border: '1px solid black', padding: '3px !important' }">{{ l.percentages }}</td>
                  </tr>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="barhorchart-table" id="barhorchart-table">
        <div class="barhor-chart-title">Total Sales by Top 10 Customers</div>
        <div class="barhor-chart-Sales" id="barhor-chart-Sales"></div>
      </div>
    </div>

    <ContextMenu v-if="showContextMenu" :show.sync="showContextMenu" :position="contextPosition" :contextItems="contextItems"
      @contextSelected="contextSelected" ref="context"/>

    <Loader :loadingText="loadText" :isVisible.sync="loading" />
  </div>
</template>

<script>
/* eslint-disable */
import Loader from '@/components/Loader.vue';
import DateTimePicker from '@/components/DateTimePicker.vue';
import CheckBox from '@/components/CheckBox';
import Tabulator from '@/components/Tabulator.vue';
import ContextMenu from '@/components/ContextMenu.vue';

export default {
  components: {
    Loader, DateTimePicker, CheckBox, Tabulator, ContextMenu
  },
  data : function() {
    return {
      byTransGroup : [],
      byCust : [],
      byMonth : [],
      byMonthCollection : [],

      loading : false ,
      loadText : 'Loading',
      isChecked : false,
      fromDate : new Date(new Date().getFullYear(), new Date().getMonth()),
      toDate: new Date(new Date().getFullYear(), new Date().getMonth(), new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0).getDate()),
      refreshDate: new Date(),

      chartBar: null,
      chartLine: null,
      chartPie: null,
      chartBarHor: null,

      customLegend: [],

      showContextMenu: false,
      contextItems: ['Sales Analysis Details for [Series]', 'Sales Analysis Summary', 'Collection Analysis Summary'] ,
      contextPosition:[ 100, 100 ]
    }
  },
  props: {},
  methods: {
    drillThroughClicked: async function(rptType, salesperson, pnlonly) {
      this.loadText = `Getting details`;
      this.loading = true;
      
      if(salesperson.includes('Sales Analysis Summary')){
        var dataToPost = {
          'startdate': this.$dateTime.getDateTime(this.fromDate, 'yyyy-MM-dd'),
          'enddate':  this.$dateTime.getDateTime(this.toDate, 'yyyy-MM-dd'),
          'rpttype': rptType,
          'pnlonly': pnlonly,
        }
        var drillThroughData = await this.$apiCallV2('/Sales/GetSalesAnalysis3', dataToPost);
        sessionStorage.setItem(`Drill Through - ${rptType == 'BY_MONTH_SALESPERSON' ? 'BY_MONTH_SALESPERSON' : ''} ${salesperson}`, 
          JSON.stringify({ data: drillThroughData, pnlonly: pnlonly, salesperson : salesperson }));
        var drillThroughLink = this.$router.resolve(`/Home/${this.$route.params['user']}/Dashboard/Sales Analysis/Drill Through - ${rptType == 'BY_MONTH_SALESPERSON' ? 'BY_MONTH_SALESPERSON' : ''} ${salesperson}`);
        window.open(drillThroughLink.href, '_blank');
      }
      else if(salesperson.includes('Collection Analysis Summary')){
        var dataToPost = {
          'startdate': this.$dateTime.getDateTime(this.fromDate, 'yyyy-MM-dd'),
          'enddate':  this.$dateTime.getDateTime(this.toDate, 'yyyy-MM-dd'),
          'rpttype': rptType,
          'pnlonly': pnlonly,
        }
        var drillThroughData = await this.$apiCallV2('/Sales/GetARCollectionAnalysis2', dataToPost);
        sessionStorage.setItem(`Drill Through - ${rptType == 'BY_MONTH_SALESPERSON' ? 'BY_MONTH_SALESPERSON' : ''} ${salesperson}`, 
          JSON.stringify({ data: drillThroughData, pnlonly: pnlonly, salesperson : salesperson }));
        var drillThroughLink = this.$router.resolve(`/Home/${this.$route.params['user']}/Dashboard/Sales Analysis/Drill Through - ${rptType == 'BY_MONTH_SALESPERSON' ? 'BY_MONTH_SALESPERSON' : ''} ${salesperson}`);
        window.open(drillThroughLink.href, '_blank');
      }
      else{
        var dataToPost = {
          'startdate': this.$dateTime.getDateTime(this.fromDate, 'yyyy-MM-dd'),
          'enddate':  this.$dateTime.getDateTime(this.toDate, 'yyyy-MM-dd'),
          'rpttype': rptType,
          'pnlonly': pnlonly,
          'salesperson': salesperson.split(' ')[1],
        }
        sessionStorage.setItem(`Drill Through - ${rptType == 'DETAILS' ? 'DETAILS' : ''} ${salesperson.split(' ')[1]}`, JSON.stringify({ data: dataToPost, series: salesperson.split(' ')[1], pnlonly: pnlonly}));
        var drillThroughLink = this.$router.resolve(`/Home/${this.$route.params['user']}/Dashboard/Sales Analysis/Drill Through - ${rptType == 'DETAILS' ? 'DETAILS' : ''} ${salesperson.split(' ')[1]}`);
        window.open(drillThroughLink.href, '_blank');
      }

      this.loading = false;
    },
    contextSelected: function(item) {
      var isChk = $( ".chkBox" ).is(":checked");
      this.drillThroughClicked(item.includes('Sales Analysis Details for ') ? 'DETAILS' : 'BY_MONTH_SALESPERSON', item.includes('Sales Analysis Details for') ? item.replace('Sales Analysis Details for','') : item , isChk ? 1 : 0 );
    },
    createChart: async function(){
      if(this.chartBar){
        this.customLegend = [];
        this.chartBar.detach();
        this.chartLine.detach();
        this.chartPie.detach();
        this.chartBarHor.detach();

        $('#barlineChart-Sales').html('');
        $('#barline2Chart-Sales').html('');
        $('#pie-chart-Sales').html('');
        $('#barhor-chart-Sales').html('');
      }

      this.loading = true;
      var formatCurrency = new Intl.NumberFormat();
      this.refreshDate = this.$dateTime.getDateTime(new Date(), 'dd/MM/yyyy HH:mm');

      if(this.isChecked){
        this.loadText = 'Getting Sales Analysis by Month (P&L txn only)';
        this.byMonth = await this.$apiCallV2(`/Sales/GetSalesAnalysis?start=${this.$dateTime.getDateTime(this.fromDate, 'yyyy-MM-dd')}&end=${this.$dateTime.getDateTime(this.toDate, 'yyyy-MM-dd')}&rptType=BY_MONTH_SALESPERSON&pnlOnly=1`);

        this.loadText = 'Getting AR Collection Analysis by Month (P&L txn only)'; 
        this.byMonthCollection = await this.$apiCallV2(`/Sales/GetARCollectionAnalysis?start=${this.$dateTime.getDateTime(this.fromDate, 'yyyy-MM-dd')}&end=${this.$dateTime.getDateTime(this.toDate, 'yyyy-MM-dd')}&rptType=BY_MONTH_SALESPERSON&pnlOnly=1`);

        this.loadText = 'Getting Sales Analysis by Transaction (P&L txn only)';
        this.byTransGroup = await this.$apiCallV2(`/Sales/GetSalesAnalysis?start=${this.$dateTime.getDateTime(this.fromDate, 'yyyy-MM-dd')}&end=${this.$dateTime.getDateTime(this.toDate, 'yyyy-MM-dd')}&rptType=BY_TRANSGROUP&pnlOnly=1`);

        this.loadText = 'Getting Sales Analysis by Customer (P&L txn only)';
        this.byCust = await this.$apiCallV2(`/Sales/GetSalesAnalysis?start=${this.$dateTime.getDateTime(this.fromDate, 'yyyy-MM-dd')}&end=${this.$dateTime.getDateTime(this.toDate, 'yyyy-MM-dd')}&rptType=BY_CUSTOMER&pnlOnly=1&showTopx=10`);
      } else{
        this.loadText = 'Getting Sales Analysis by Month';
        this.byMonth = await this.$apiCallV2(`/Sales/GetSalesAnalysis?start=${this.$dateTime.getDateTime(this.fromDate, 'yyyy-MM-dd')}&end=${this.$dateTime.getDateTime(this.toDate, 'yyyy-MM-dd')}&rptType=BY_MONTH_SALESPERSON`);

        this.loadText = 'Getting AR Collection Analysis by Month'; 
        this.byMonthCollection = await this.$apiCallV2(`/Sales/GetARCollectionAnalysis?start=${this.$dateTime.getDateTime(this.fromDate, 'yyyy-MM-dd')}&end=${this.$dateTime.getDateTime(this.toDate, 'yyyy-MM-dd')}&rptType=BY_MONTH_SALESPERSON`);

        this.loadText = 'Getting Sales Analysis by Transaction';
        this.byTransGroup = await this.$apiCallV2(`/Sales/GetSalesAnalysis?start=${this.$dateTime.getDateTime(this.fromDate, 'yyyy-MM-dd')}&end=${this.$dateTime.getDateTime(this.toDate, 'yyyy-MM-dd')}&rptType=BY_TRANSGROUP`);

        this.loadText = 'Getting Sales Analysis by Customer';
        this.byCust = await this.$apiCallV2(`/Sales/GetSalesAnalysis?start=${this.$dateTime.getDateTime(this.fromDate, 'yyyy-MM-dd')}&end=${this.$dateTime.getDateTime(this.toDate, 'yyyy-MM-dd')}&rptType=BY_CUSTOMER&showTopx=10`);
      }
      
      this.loading = false;
      
      if(this.byMonth.includes('error'))
        document.getElementById('barlineChart-Sales').innerHTML = "<div style=\"padding-top: 100px; text-align: center; font-weight: bold; font-size: 10px;\">An error occurred. Please try again.</div>";
      else if(this.byMonth.length == 0)
        document.getElementById('barlineChart-Sales').innerHTML = "<div style=\"padding-top: 100px; text-align: center; font-weight: bold; font-size: 10px;\">No records found.</div>";
      else{
        this.refreshDate = this.$dateTime.getDateTime(new Date(), 'dd/MM/yyyy HH:mm');
        
        var formatCurrency = new Intl.NumberFormat();
        var currencyUnit = this.byTransGroup[0]['Currency'];
        var dynamicSeriesName = Object.keys(this.byMonth[0]).filter((o) => { return o != 'Month Name' && o != 'Month' && o != 'Currency'});
        var dynamicSeries = dynamicSeriesName.map((d) => {
          return {
            name: d,
            data: this.byMonth.map((p) => { return p[d] })
          }
        });
        
        var value = dynamicSeriesName.map((d) => {
          return {
            data: Math.max(...this.byMonth.map((p) => { return p[d] })),
            data1: Math.min(...this.byMonth.map((p) => { return p[d] }))
          }
        });
        var maxValue = Math.max(...value.map((p) => { return p.data }));
        var minValue = Math.min(...value.map((p) => { return p.data1 }));
        if(this.isChecked){
          var maxValueTopChart = maxValue;
          var minValueTopChart = minValue;
        }

        if(!this.isChecked){
          document.getElementById("barline2Chart-Sales").hidden = false;
          var dynamicSeriesName2 = Object.keys(this.byMonthCollection[0]).filter((o) => { return o != 'Month Name' && o != 'Month' && o != 'Currency'});
          var dynamicSeries2 = dynamicSeriesName2.map((d) => {
            return {
              name: d,
              data: this.byMonthCollection.map((p) => { return p[d] })
            }
          });
          var value2 = dynamicSeriesName2.map((d) => {
            return {
              data: Math.max(...this.byMonthCollection.map((p) => { return p[d] })),
              data1: Math.min(...this.byMonthCollection.map((p) => { return p[d] }))
            }
          });
          var maxValue2 = Math.max(...value2.map((p) => { return p.data }));
          var minValue2 = Math.min(...value2.map((p) => { return p.data1 }));
          var maxValueTopChart = Math.max(maxValue, maxValue2);
          var minValueTopChart = Math.min(minValue, minValue2);
        }

        this.chartBar = new Chartist.Bar('.barlineChart-Sales', {
          labels: this.byMonth.map((m) => { return m['Month Name'] }),
          series: dynamicSeries
        }, {
          chartPadding: {top: 0,right: 40,bottom: 30,left: 40},
          fullWidth: true,  
          high: maxValueTopChart,
          low: minValueTopChart,
          axisY: {offset: 30, scaleMinSpace: 20,showLabel: true},
          plugins: [ Chartist.plugins.legend( { position: 'top', className: "barlineChart-Sales"} ) ]
        });

        if(!this.isChecked){
          this.chartLine = new Chartist.Line('.barline2Chart-Sales', {
            series: dynamicSeries2
          }, 
          {
            chartPadding: {top: 0,right: 40,bottom: 30,left: 40},
            fullWidth: true, 
            high: maxValueTopChart, 
            low: minValueTopChart,
            axisY: {offset: 30, scaleMinSpace: 20, showLabel: false, showGrid: false},
            axisX: {showGrid: false},
          });

          var $tooltip = $('<div class="tooltip tooltip-hidden"></div>').appendTo($('.barline2Chart-Sales'));
          $(document).on('mouseenter', '.ct-point', function() {
            var seriesName = $(this).closest('.ct-series').attr('ct:series-name'), value = $(this).attr('ct:value');

            $tooltip.html("<span>" + seriesName + "<br/> " + currencyUnit + " " + formatCurrency.format(value) + "</span>");
            $tooltip.removeClass('tooltip-hidden');
          });

          $(document).on('mouseleave', '.ct-point', function() {
            $tooltip.addClass('tooltip-hidden');
          });

          $(document).on('mousemove', '.ct-point', function(event) {
            $tooltip.css({
              left: event.pageX - 100,
              top: event.pageY - 200
            });
          });
        }else{
          document.getElementById("barline2Chart-Sales").hidden = true;
          
          var $tooltip = $('<div class="tooltip tooltip-hidden"></div>').appendTo($('.barlineChart-Sales'));
          $('#barlineChart-Sales').on('mouseenter', '.ct-bar', function() {
            var seriesName = $(this).closest('.ct-series').attr('ct:series-name'), value = $(this).attr('ct:value');
            
            $tooltip.html("<span>" + seriesName + "<br/> " + currencyUnit + " " + formatCurrency.format(value) + "</span>");
            $tooltip.removeClass('tooltip-hidden');
          });

          $('#barlineChart-Sales').on('mouseleave', '.ct-bar', function() {
            $tooltip.addClass('tooltip-hidden');
          });

          $('#barlineChart-Sales').on('mousemove', '.ct-bar', function(event) {
            $tooltip.css({
              left: event.pageX - 100,
              top: event.pageY - 165
            });
          });
        }
      }

      if(this.byTransGroup.includes('error'))
        document.getElementById('pie-chart-Sales').innerHTML = "<div style=\"padding-top: 100px; text-align: center; font-weight: bold; font-size: 10px;\">An error occurred. Please try again.</div>";
      else if(this.byTransGroup.length == 0)
        document.getElementById('pie-chart-Sales').innerHTML = "<div style=\"padding-top: 150px; text-align: center; font-weight: bold; font-size: 10px;\">No records found.</div>";
      else{
        var dynamicSeriesName3 = Object.keys(this.byTransGroup[0]).filter((o) => { return o != 'Txn Group' && o != 'Sales %' && o != 'Currency'});
        var dynamicSeries3 = this.byTransGroup.map((p) => { return p[dynamicSeriesName3] });
        this.byTransGroup.map((p) => { return p[dynamicSeriesName3] = formatCurrency.format(p[dynamicSeriesName3]) });

        var legendName = Object.keys(this.byTransGroup[0]).filter((o) => { return o != 'TotalSales' && o != 'Sales %' && o != 'Currency'});
        var salesName = Object.keys(this.byTransGroup[0]).filter((o) => { return o != 'Txn Group' && o != 'Sales %' && o != 'Currency'});
        var currencyName = Object.keys(this.byTransGroup[0]).filter((o) => { return o != 'Txn Group' && o != 'Sales %' && o != 'TotalSales'});
        var percentageName = Object.keys(this.byTransGroup[0]).filter((o) => { return o != 'Txn Group' && o != 'TotalSales' && o != 'Currency'});
        var legend = this.byTransGroup.map((p) => { return { name: p[legendName], value: p[salesName], currency: p[currencyName], percentages: p[percentageName] } } ) ;
        legend.forEach((d) => {
          this.customLegend.push({
            name: d.name,
            value: d.value,
            currency: d.currency,
            percentages: d.percentages,
          });
        });
        
        this.chartPie = new Chartist.Pie('.pie-chart-Sales', {
          labels: this.byTransGroup.map((b) => { return b['Txn Group'] + " - " + b['Currency'] + ' ' + b['TotalSales'] + ' - ' + b['Sales %'] + '%'}),
          series: dynamicSeries3
        }, 
        {
          fullWidth: true,
          showLabel: false,
        });
      }

      if(this.byCust.includes('error'))
        document.getElementById('barhor-chart-Sales').innerHTML = "<div style=\"padding-top: 100px; text-align: center; font-weight: bold; font-size: 10px;\">An error occurred. Please try again.</div>";
      else if(this.byCust.length == 0)
        document.getElementById('barhor-chart-Sales').innerHTML = "<div style=\"padding-top: 150px; text-align: center; font-weight: bold; font-size: 10px;\">No records found.</div>";
      else{
        var dynamicSeriesName4 = Object.keys(this.byCust[0]).filter((o) => { return o != 'customer_ranking' && o != 'Customer' && o != 'Currency'});
        var dynamicSeries4 = dynamicSeriesName4.map((d) => {
          return {
            name: d,
            data: this.byCust.map((p) => { return p[d] })
          }
        });

        var value4 = dynamicSeriesName4.map((d) => {
          return {
            data: Math.max(...this.byCust.map((p) => { return p[d] })),
            data1: Math.min(...this.byCust.map((p) => { return p[d] }))
          }
        });
        var maxValue4 = Math.max(...value4.map((p) => { return p.data }));
        var minValue4 = Math.min(...value4.map((p) => { return p.data1 }));

        this.chartBarHor = new Chartist.Bar(".barhor-chart-Sales", {
          labels: this.byCust.map(c => {return c["Customer"];}),
          series: dynamicSeries4
        },
        {
          chartPadding: {top: 10,right: 0,bottom: 15,left: 20},
          high: maxValue4,
          low: minValue4,
          fullWidth: true,
          reverseData: true,
          horizontalBars: true,
          axisY: {offset: 180},
          axisX: {scaleMinSpace: 50},
          plugins: [ Chartist.plugins.ctPointLabels( { textAnchor: 'start', labelInterpolationFnc: function(value) {return currencyUnit + formatCurrency.format(value.toFixed(2)) } } ) ]
        });
      }

      var mainContainer = this;
      var series;
      $('document').ready(() => {
        $(document).on('click', '.ct-point', function(e) {
          series = $(this).closest('.ct-series').attr('ct:series-name');
          mainContainer.showContextMenu = true;
          mainContainer.contextItems = [ 'Sales Analysis Details for ' + series, 'Sales Analysis Summary', 'Collection Analysis Summary' ];
          
          mainContainer.$nextTick(() => {
            mainContainer.contextPosition = [ e.clientY - (mainContainer.$refs.context.$el.clientHeight - 125), e.clientX + 15];
          });
        });
      });

      $('#barlineChart-Sales').ready(() => {
        $('#barlineChart-Sales').on('click', '.ct-bar', function(e) {
          series = $(this).closest('.ct-series').attr('ct:series-name');
          mainContainer.showContextMenu = true;
          mainContainer.contextItems = [ 'Sales Analysis Details for ' + series, 'Sales Analysis Summary', 'Collection Analysis Summary' ];
          
          mainContainer.$nextTick(() => {
            mainContainer.contextPosition = [ e.clientY - (mainContainer.$refs.context.$el.clientHeight - 125), e.clientX + 15];
          });
        });
      });
    },
    refreshChart: async function(){
      this.createChart();
    }
  },
  watch: {
    fromDate: function(val) {
      this.$emit('update:fromDate', val);  
    },
    toDate: function(val) {
      this.$emit('update:toDate', val);
    }
  },
  async mounted() {
    this.createChart();
  }
};
</script>

<style lang="scss" scoped>
@import '@/css/all.scss';
.sales-main{
  font-size: 12px;
  padding: 5px 45px;

  > .option-container {
    width: 100%;
    height: 30px;
    display: flex;
    background-color: white;
    border-radius: 5px;
    margin: 0 0 3px 0;
    flex-direction: row;
    // justify-content: space-between;

    > .filter-list {
      width: 70%;
      height: 100%;
      display: flex;
      flex-direction: row;
      padding: 5px;

      button {
        padding: 0.5px;
      }
    }

    > .last-refresh {
      width: 30%;
      height: 100%;
      padding: 5px;

      span {
        float: right;
      }
    }

    >.chkBox-show-pl-txn-only{
      margin: 5px 0px;
      width: 225px;
      // width: 100%;
    }
      
    > button {
      margin: 2px 0 3px 0;
      height: calc(100% - 10%);
    }

    > .refresh-last{
      width: 100%;
      text-align: end;
      padding: 5px;
    }
  }

  > .top-chart-container{
    height: calc(100% - 60%);
    min-width: 100%;
    background-color: white;
    border-radius: 5px;

    >.title-top-chart{
      display: flex;
      width: 100%;
      height: calc( 100% - 90%);
      font-size: 12px;
      color: black;
      font-weight: bold;

      >.barlinechart-title{
        height: 100%;
        width: calc( 100% - 300px);
        margin-left: 10px;
      }

      >.custom-legend{
        display: flex;
        >.legend-box-Sales{
          width: 50px;
          height: 10px;
          background-color: grey;
          margin: 5px;
        }

        >.legend-box-Collection1,.legend-box-Collection2,.legend-box-Collection3,.legend-box-Collection4,.legend-box-Collection5{
          width: 10px;
          height: 2px;
          background-color: grey;
          margin: 7.5px 5px 7.5px 5px ;
        }
      }
    }

    >.barlinechart-table{
      width: 100%;
      height: 90%;
      position: relative;

      >.barlineChart-Sales{
        width: 100%;
        height: 100%;
        font-size: 10px;
		    color: black;
      }
      >.barline2Chart-Sales{
        width: 100%;
        height: 100%;
        position: absolute;
        top: 34px;
      }
    }
  }

  > .bottom-chart-container{
    display: flex;
    flex-wrap: wrap;
    height: calc(60% - 5%);
    width: 100%;
    justify-content: center;
  
    >.piechart-table{
      flex-grow: 1;
      min-width: 45%;
      margin: 3px;
      background-color: white;
      border-radius: 5px;
      height: calc(100% - 10px);
      
      >.pie-chart-title{
        height: calc( 100% - 90%);
        width:  calc( 100% - 10px);
        margin-left: 10px;
        font-size: 12px;
        color: black;
        font-weight: bold;
      }

      >.pie-chart-container{
        width: 100%;
        height: 90%;
        display: flex;

        >.pie-chart-Sales{
          width: calc(100% - 40%);
          height: 100%;
        }

        >.legend{
          width: 40%;
          height: 100%;
          padding-left: 3px;
          margin: 3px;

          > .legend-row {
            display: flex;
            align-items: center;
            padding: 3px 0;
            width: 100%;
            height: 100%;

            > .table {
              width: 100%;
              height: 100%;
              overflow-x: scroll;
              overflow-y: scroll;
              line-height: 1;

              > .details-table {
                width: 100%;
                height: 100%;
                border: 1px solid black;
                font-size: 10px;
              }
            }
          }
        }
      }
    }

    >.barhorchart-table{
      flex-grow: 1;
      min-width: 50%;
      background-color: white;
      border-radius: 5px;
      margin: 3px 3px 3px 0;
      height: calc(100% - 10px);

      >.barhor-chart-title{
        height: calc( 100% - 90%);
        width: calc( 100% - 10px);
        margin-left: 10px;
        font-size: 12px;
        color: black;
        font-weight: bold;
      }

      >.barhor-chart-Sales{
        width: 100%;
        height: 100%;
      }
    }
  }
}

tr td:nth-child(1){
  font-weight: bold;
}

tr:nth-child(1){
  text-align: right;
  > th:nth-child(1){
    text-align: left;
  }
}

td{
  text-align: right;
}
td:nth-child(1){
  text-align: left;
}

tr:nth-child(2) td:nth-child(1){ 
	background-color: #ff6358;
}
tr:nth-child(3) td:nth-child(1){
	background-color: #ffd246;
}
tr:nth-child(4) td:nth-child(1){
	background-color: #28b4c8;
}
tr:nth-child(5) td:nth-child(1){
	background-color: #49ff2f;
}
tr:nth-child(6) td:nth-child(1){
	background-color: #b773f5;
}
tr:nth-child(7) td:nth-child(1){
	background-color: #2d73f5;
}
tr:nth-child(8) td:nth-child(1){
	background-color: #ff2113;
}
tr:nth-child(9) td:nth-child(1){
	background-color: #ff72b3;
}
tr:nth-child(10) td:nth-child(1){
	background-color: #dcd89e ;
}
tr:nth-child(11) td:nth-child(1){
	background-color: #6cf6e0;
}
tr:nth-child(12) td:nth-child(1){
	background-color: #eb7614;
}
tr:nth-child(13) td:nth-child(1){
	background-color: #1f65e1;
}
tr:nth-child(14) td:nth-child(1){
	background-color: #78d237;
}
tr:nth-child(15) td:nth-child(1){
	background-color: #0aadf6;
}
tr:nth-child(16) td:nth-child(1){
	background-color: #DAF7A6;
}
tr:nth-child(17) td:nth-child(1){
	background-color: #fafe13;
}
tr:nth-child(18) td:nth-child(1){
	background-color: #d4ccfe;
}
tr:nth-child(19) td:nth-child(1){
	background-color: #FFA07A;
}
tr:nth-child(20) td:nth-child(1){
	background-color: #2471A3 ;
}
tr:nth-child(21) td:nth-child(1){
	background-color: #B3B6B7;
}
tr:nth-child(22) td:nth-child(1){
	background-color: #afeeee;
}
tr:nth-child(23) td:nth-child(1){
	background-color: #ffc0cb;
}
tr:nth-child(24) td:nth-child(1){
	background-color: #b6fcd5;
}
tr:nth-child(25) td:nth-child(1){
	background-color: #c6e2ff;
}
tr:nth-child(26) td:nth-child(1){
	background-color: #fa8072;
}
</style>